import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { NewClient, ServerResponse } from '@models';
import { ModalSuccessService } from '@modules';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalNewClientService {
  public response: Subject<boolean> = new Subject<boolean>();

  public clientsList: Subject<boolean> = new Subject<boolean>();

  private broker = environment.BROKER;
  private clientManage = environment.CLIENT_MANAGE;

  constructor(
    private modalSuccess: ModalSuccessService,
    private readonly http: HttpClient
  ) {}

  public continue(): void {
    this.response.next(true);
  }

  public close(): void {
    this.response.next(false);
  }

  /**
   * Post create project
   */
  public postCreateClient(): void {
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Completar proyecto');
  }

  /**
   * Post get all brokers
   */
  public getBrokers(): Observable<ServerResponse> {
    const path = this.broker.BROKER;
    return this.http.get<ServerResponse>(path);
  }

  /**
   * Post get all brokers
   */
  public createVisit(admin: any): Observable<ServerResponse> {
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Cerrar');
    const path = this.broker.BROKER_VISIT;
    return this.http.post<ServerResponse>(`${path}`, admin);
  }

  /**
   * Create a new client
   * @param client client data
   */
  public createClient(client: NewClient): Observable<ServerResponse> {
    const path = this.clientManage.CLIENT;
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Cerrar');
    return this.http.post<ServerResponse>(path, client);
  }
}
